<template>
  <b-modal
    v-model="modal"
    class="position-relative"
    lazy
    centered
    body-class="py-5"
    content-class="new-section-modal"
    size="lg"
    hide-footer
    hide-header
  >
    <h3 class="text-center font-weight-bold mb-12 px-0">
      {{ variable ? 'Edit' : 'New' }} Global Variable
    </h3>

    <b-form
      class="px-4"
      @submit.prevent="submit"
    >
      <b-row>
        <b-col>
          <b-form-group
            class="estage-form-group"
            label="Name"
            label-class="font-medium"
          >
            <b-input
              v-model="form.name"
              v-validate="'required'"
              name="name"
              :state="errors.has('name') ? false : null"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            class="estage-form-group"
            label="Key"
            label-class="font-medium"
          >
            <b-input
              v-model="form.key"
              v-validate="'required'"
              name="key"
              :state="errors.has('key') ? false : null"
              @input="form.key = form.key.toLowerCase().replace(/\s/g, '-')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            class="estage-form-group"
            label="Type"
            label-class="font-medium"
          >
            <v-select
              v-model="form.type"
              :options="variableTypes"
              label="text"
              :reduce="option => option.value"
              @input="form.value = ''"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            class="estage-form-group"
            label="Folder"
            label-class="font-medium"
          >
            <v-select
              v-model="form.folder"
              :options="[
                {
                  key: null,
                  name: 'Root'
                },
                ...folders
              ]"
              :reduce="option => option.key"
              label="name"
              placeholder="Root"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            class="estage-form-group"
            label="Value"
            label-class="font-medium"
          >
            <v-select
              v-if="form.type === 'modal'"
              v-model="form.value"
              :options="modals"
              :reduce="option => option.id"
              label="name"
              placeholder="Select Modal"
            />

            <b-form-textarea
              v-else-if="form.type === 'text'"
              v-model="form.value"
              v-validate="'required'"
              class="font-[Inter]"
            />

            <b-input
              v-else
              v-model="form.value"
              v-validate="'required'"
              class="font-[Inter]"
              @change="form.value = ensureLink(form.value)"
            />
          </b-form-group>
        </b-col>
        <b-col />
      </b-row>

      <div class="text-center mt-5">
        <b-btn
          type="submit"
          variant="primary"
          class="font-weight-bold font-size-14 px-5"
          :disabled="loading"
        >
          {{ variable ? 'Update' : 'Create' }}
          <b-spinner
            v-if="loading"
            class="mr-2"
            variant="light"
            small
          />
        </b-btn>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'GlobalVariableManage',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    activeFolder: {
      type: [Object, null],
      required: false,
      default: null
    },
    folders: {
      type: Array,
      required: false,
      default: () => []
    },
    variable: {
      type: [Object, null],
      required: false,
      default: null
    }
  },
  computed: {
    ...mapState('modal', {
      modals: state => state.modals
    }),
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      form: {
        name: '',
        key: '',
        type: 'link',
        value: ''
      },
      variableTypes: [
        {
          value: 'link',
          text: 'Link'
        },
        {
          value: 'modal',
          text: 'Modal'
        },
        {
          value: 'text',
          text: 'Text'
        }
      ],
      loading: false
    }
  },
  watch: {
    modal (val) {
      if (val) {
        if (this.variable) {
          this.form = {
            ...this.variable,
            name: this.variable.name,
            key: this.variable.key,
            type: this.variable.type,
            value: this.variable.value,
            folder: this.variable.folder
          }
        } else {
          this.form = {
            name: '',
            key: '',
            type: 'link',
            value: '',
            folder: this.activeFolder?.key || null
          }
        }
        this.loading = false
      }
    }
  },
  methods: {
    submit () {
      if (this.variable) {
        this.$emit('update', this.form)
      } else {
        this.$emit('create', this.form)
      }
      this.modal = false
    },
    validateDomain (value) {
      const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+(\.[a-zA-Z0-9-_]+)*\.[a-zA-Z]{2,})$/
      return domainRegex.test(value)
    },
    ensureLink (value) {
      if (this.validateDomain(value) && !/^https?:\/\//i.test(value)) {
        return `https://${value.trim()}`
      }
      return value.trim()
    }
  }
}
</script>
